import { api } from './api';

export interface DashboardMetrics {
  tickets: {
    total: number;
    abiertos: number;
    cerrados_hoy: number;
    por_estado: Record<string, number>;
  };
  conversaciones: {
    total: number;
    activas: number;
    esperando_respuesta: number;
  };
  actividades: {
    pendientes: number;
    vencidas: number;
    completadas_hoy: number;
  };
  clientes: {
    total: number;
    activos: number;
  };
}

export interface ActividadReciente {
  id: string;
  tipo: 'TICKET' | 'CONVERSACION' | 'ACTIVIDAD' | 'CLIENTE';
  descripcion: string;
  usuario: {
    id: string;
    nombre: string;
    avatar_url?: string;
  };
  entidad_id: string;
  created_at: string;
}

export const dashboardService = {
  async getMetricas(): Promise<DashboardMetrics> {
    return api.get<DashboardMetrics>('/reportes/dashboard/metricas');
  },

  async getActividadReciente(limit = 10): Promise<ActividadReciente[]> {
    return api.get<ActividadReciente[]>(`/reportes/actividad-reciente?limit=${limit}`);
  },

  async getTicketsPorMes(): Promise<Array<{ mes: string; cantidad: number }>> {
    return api.get<Array<{ mes: string; cantidad: number }>>('/reportes/tickets-por-mes');
  },
};
